<template>
  <div class="department-info">
    <!-- 仓库信息 -->
    <div class="department-info-left">
      <div class="search-warehouse">
        <el-input
          v-model="searchWarehouseName" 
          suffix-icon="el-icon-search" 
          placeholder="请输入部门名称"
          @keyup.enter.native="searchWarehouseNameFnc"
        ></el-input>
      </div>
      <div class="warehouse-container" :class="{'warehouse-container-active':scrollHeight > offsetHeight}">
        <div 
          class="warehouse-row"
          :class="{'is-active': activeIndex === index}"
          v-for="(item, index) in warehouseList"
          :key="index"
          @click="selectWarehouse(item, index)"
        >
          {{ item.name }}
        </div>
      </div>
    </div>

    <!-- 部门信息列表 -->
    <div class="department-info-right">
      <div class="department-info-right-top">
        <p class="sub-title">{{ form.warehouseName }}</p>
        <el-button class="btn-blue" @click="addChildDepartment" icon="el-icon-plus">新增子部门</el-button>
      </div>
      <div class="department-info-right-container">
        <div class="table" v-if="tableData.length">
          <el-table :data="tableData" style="width: 100%">
            <el-table-column
              v-for="(item, index) in tableTitleList"
              :key="index"
              :prop="item.prop"
              :label="item.label"
              show-overflow-tooltip
              :min-width="item.width"
            ></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button class="btn-text" type="text" @click="updateDepartment(scope.row)">编辑</el-button>
                <el-button class="btn-red-text" type="text" @click="delDepartment(scope.row.id)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-else class="nothing">
          <img class="nothing-img" src="../../../../../assets/images/nothing/department-info-nothing.png">
        </div>
      </div>
    </div>

    <!-- 编辑部门 -->
    <el-drawer
      class="mod-department"
      :title="drawerTitle"
      :visible.sync="drawer"
      :wrapperClosable="false"
      :before-close="handleCloseDrawer">
      <div class="el-drawer__body">
        <el-form ref="form" :model="form" :rules="rules">
          <el-form-item label="仓库名称" prop="warehouseName">
            <el-input v-model="form.warehouseName" placeholder="请输入" disabled></el-input>
          </el-form-item>
          <el-form-item label="部门名称" prop="department">
            <el-input v-model="form.department" placeholder="请输入部门名称"></el-input>
          </el-form-item>
        <el-form-item label="考勤" prop="isAttendance">
          <el-select v-model="form.isAttendance" placeholder="请选择考勤">
            <el-option
              v-for="item in ATTENDANCE_LIST"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分摊规则" prop="shareType">
          <el-select v-model="form.shareType" placeholder="请选择分摊规则">
            <el-option
              v-for="item in SHARE_TYPE_LIST"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        </el-form>
      </div>
      <div class="drawer-footer">
        <el-button class="btn-gray" @click="handleCloseDrawer">取消</el-button>
        <el-button class="btn-blue" @click="confirm('form')">确定</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import Employee from "models/employee";
const employee = new Employee();
import warehouseMixins from "@/common/mixins/warehouse.js"
import statusMixins from "@/common/mixins/status.js"
import { fuzzyQuery } from "common/js/util";
export default {
  mixins: [warehouseMixins, statusMixins],

  data() {
    return {
      // 选择的仓库id
      warehouseId: null,
      searchWarehouseName: '',
      // 仓库实际高度
      scrollHeight: null,
      // 仓库页面高度
      offsetHeight: null,
      activeIndex: 0,
      tableData: [],
      tableTitleList: [
        {label: '部门名称', prop: 'name', width: ''},
        {label: '考勤', prop: 'isAttendanceText', width: ''},
        {label: '分摊规则', prop: 'shareTypeText', width: ''},
      ],
      drawer: false,
      drawerTitle: '新增子部门',
      form: {
        departmentId: null,
        warehouseName: '',
        department: '',
        isAttendance: null,
        shareType: null
      },
      rules: {
        department: [
          { required: true, message: '请输入部门名称', trigger: 'blur' },
        ],
        isAttendance: [
          { required: true, message: '请选择考勤', trigger: 'change' },
        ],
        shareType: [
          { required: true, message: '请选择分摊规则', trigger: 'change' },
        ],
      },
    }
  },

  async created() {
    await this.initAsyncWarehouse()
    this.selectWarehouse(this.warehouseList[0],0)
  },

  mounted() {
    this.initHeight()
  },

  methods: {
    initDepartmentList() {
      let warehouseId = this.warehouseId
      employee.getDeptList(warehouseId).then(res => {
        if (res.success) {
          let arr = []
          res.result.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            obj.type = 2;
            obj.warehouseId = value.warehouseId;
            obj.warehouseName = value.warehouseName;
            obj.isAttendanceText = value.isAttendance === 0 ? "否" : "是";
            obj.isAttendance = value.isAttendance;
            obj.shareTypeText =
              value.shareType === 1 ? "订单比例 " : "订单复杂度";
            obj.shareType = value.shareType;
            arr.push(obj);
          });
          this.tableData = arr;
        }
      });
    },

    initHeight() {
      this.scrollHeight = document.getElementsByClassName('warehouse-container')[0].scrollHeight
      this.offsetHeight = document.getElementsByClassName('warehouse-container')[0].offsetHeight
    },

    /** 
     * @desc 选择仓库
    */
    selectWarehouse(row, index) {
      this.activeIndex = index
      this.warehouseId = row.id
      this.form.warehouseName = row.name
      this.initDepartmentList()
    },

    searchWarehouseNameFnc() {
      this.warehouseList = fuzzyQuery(this.warehouseListCopy, item => item.name.indexOf(this.searchWarehouseName) !== -1)
    },

    /** 
     * @desc 删除部门
    */
    delDepartment(id) {
      this.$confirm("删除后，该部门将不再存在，请确认", "删除", {
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        confirmButtonClass: 'btn-red',
        cancelButtonClass: 'btn-gray'
      }).then(() => {
        let data = {
          id
        };
        employee.postDelDept(data).then(res => {
          if (res.success) {
            this.initDepartmentList();
          } else {
            this.$message.error(res.message);
          }
        });
      });
    },

    addChildDepartment() {
      this.drawerTitle = "新增子部门";
      this.drawer = true;
    },

    /**
     * @desc 开启编辑部门
     */
    updateDepartment(value) {
      this.drawerTitle = "编辑子部门";
      this.form.departmentId = value.id;
      this.form.department = value.name;
      this.form.isAttendance = value.isAttendance;
      this.form.shareType = value.shareType;
      this.drawer = true;
    },

    handleCloseDrawer() {
      this.$refs['form'].resetFields();
      this.drawer = false
    },

    confirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let warehouseId = this.warehouseId
          let name = this.form.department
          let isAttendance = this.form.isAttendance
          let shareType = this.form.shareType
          let data = {
            warehouseId,
            name,
            isAttendance,
            shareType,
          }
          if (this.form.departmentId) {
            data.id = this.form.departmentId;
            employee.postUpdateDept(data).then(res => {
              if (res.success) {
                this.initDepartmentList();
                this.handleCloseDrawer()
              } else {
                this.$message.error(res.message);
              }
            });
          } else {
            employee.postAddDept(data).then(res => {
              if (res.success) {
                this.initDepartmentList();
                this.handleCloseDrawer()
              } else {
                this.$message.error(res.message);
              }
            });
          }
         } else {
          console.log('error submit!!');
          return false;
        }
      });

    }
  }
}
</script>

<style lang='scss'>
@import '@/assets/style/layout/warehouse/department-info.scss';
</style>
